import { render, staticRenderFns } from "./PDFPaginator.vue?vue&type=template&id=caa30796&scoped=true&"
import script from "./PDFPaginator.vue?vue&type=script&lang=js&"
export * from "./PDFPaginator.vue?vue&type=script&lang=js&"
import style0 from "./PDFPaginator.vue?vue&type=style&index=0&id=caa30796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa30796",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VIcon,VTextField})
